window.addEventListener('load', function () {
    document.addEventListener('click', function (e) {
        const target = e.target.closest('.js-tab')
        if (!target) return

        changeTab(target)
    })

    const changeTab = (tab) => {
        const id = tab.dataset.tabId
        if (!id) return

        removeActiveTab(tab)
        activateTab(tab, id)
    }

    const removeActiveTab = (tab) => {
        const tabsList = tab.closest('.js-tabs-list')
        const activeTab = tabsList.querySelector('.js-tab.active')

        if (!activeTab) return

        const activeTabId = activeTab.dataset.tabId
        const activeTabContent = document.querySelector(`.js-tabs-content#${activeTabId}`)
        activeTab.classList.remove('active')
        activeTabContent.classList.add('hidden')
    }

    const activateTab = (tab, id) => {
        const activeTabContent = document.querySelector(`.js-tabs-content#${id}`)
        tab.classList.add('active')
        activeTabContent.classList.remove('hidden')
    }
})
